export default __webpack_public_path__ + "static/media/profile.548fc9dc.jpg";